<template>
  <div class="mx-4 grid grid-cols-6 gap-6 py-4">
    <div class="force-inline-flex loading-gradient col-span-1 rounded-full">
      <div class="block h-4 w-full rounded-full p-3" />
    </div>
    <div class="force-inline-flex loading-gradient col-span-4 rounded-lg">
      <div class="block h-4 w-full rounded-lg p-3" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'FMSCALoadingItem',
};
</script>

<style scoped></style>
